import { render, staticRenderFns } from "./HomeBarragan.vue?vue&type=template&id=723ed380&scoped=true&"
import script from "./HomeBarragan.vue?vue&type=script&lang=js&"
export * from "./HomeBarragan.vue?vue&type=script&lang=js&"
import style0 from "./HomeBarragan.vue?vue&type=style&index=0&id=723ed380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723ed380",
  null
  
)

export default component.exports